"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAgentProfileArticle = void 0;
exports.defaultAgentProfileArticle = {
    image: 'https://images.okay.com/ContentThumbnail/Original/832_636899893923318328.png',
    caption: 'OKAY.com’s Director (Residential Division) Andrea Ott was featured on TVB’s Hong Kong property program “Closer Look At Property” (「樓市點睇」) on 1 April 2019, where she showcased an apartment in Cherry Crest, Mid-levels West',
    title: 'OKAY.com Director Andrea Adams Ott Promotes Cherry Crest on TVB',
    date: '4 Apr 2019',
    url: 'http://google.com'
};
